import type { SystemConfig } from '@chakra-ui/react';
import type { useThemeContextValue } from './context';

export enum ThemeMode {
  AUTO = 'auto',
  LIGHT = 'light',
  DARK = 'dark',
}

export type ThemeModeValue = ThemeMode.LIGHT | ThemeMode.DARK;

export type ThemeConfig = SystemConfig;

export type ThemeProviderValue = ReturnType<typeof useThemeContextValue>;
